import './AutoTrackingGlyph.scss';
import React from 'react';
import { Lock } from '@bblabs/module-library/svgs';

export type Props = {
  displayHoverInfo?: boolean;
};

/**
 * Handles the rendering and optional overlay of the "Auto Track" label/
 */
export function AutoTrackingGlyph({ displayHoverInfo = true }: Props) {
  return (
    <span className="auto-tracking-glyph">
      <Lock />
      <span>Auto-Tracking</span>
      {displayHoverInfo && (
        <div className="info-hover">Only emails with BombBomb videos will be tracked.</div>
      )}
    </span>
  );
}
